import { apiRequest } from "../apiClient";
import { getStorageOwner, ownerStorage } from "./ownerStorage";
export async function flushRevocations() {
  const owner = { ...getStorageOwner(), persistent: true };
  const queue: string[] = JSON.parse(
    ownerStorage.getItem("consent-revocations", {
      ...getStorageOwner(),
      persistent: true,
    }) || "[]",
  );
  for (const scope of queue) {
    await apiRequest("/privacy/consent", {
      method: "POST",
      body: JSON.stringify({ scope, granted: false }),
    });
    const current = getStorageOwner();
    if (current.userId !== owner.userId || current.tenantId !== owner.tenantId)
      return;
    const latest: string[] = JSON.parse(
      ownerStorage.getItem("consent-revocations", owner) || "[]",
    );
    ownerStorage.setItem(
      "consent-revocations",
      JSON.stringify(latest.filter((s) => s !== scope)),
      owner,
    );
  }
}
export async function queueRevocation(scope: string) {
  const queue: string[] = JSON.parse(
    ownerStorage.getItem("consent-revocations", {
      ...getStorageOwner(),
      persistent: true,
    }) || "[]",
  );
  if (!queue.includes(scope))
    ownerStorage.setItem(
      "consent-revocations",
      JSON.stringify([...queue, scope]),
      { ...getStorageOwner(), persistent: true },
    );
  await flushRevocations();
}
